module.exports = __webpack_public_path__ + "static/media/Cus360.8ed5243f.png";